import React, { useEffect, useState } from 'react';
import useInView from '../hooks/useInView';
import { useSensory } from '../context/SensoryContext';

// Counts up from 0 to `value` the first time it scrolls into view.
const Counter = ({ value, prefix = '', suffix = '', duration = 1600 }) => {
  const [ref, inView] = useInView({ threshold: 0.4, rootMargin: '0px' });
  const { reducedMotion } = useSensory();
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!inView) return undefined;
    if (reducedMotion || value === 0) {
      setCurrent(value);
      return undefined;
    }
    let frame;
    const start = performance.now();
    const tick = (now) => {
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 4);
      setCurrent(Math.round(eased * value));
      if (t < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [inView, value, duration, reducedMotion]);

  return (
    <span ref={ref} aria-label={`${prefix}${value}${suffix}`}>
      <span aria-hidden="true">
        {prefix}
        {current}
        {suffix}
      </span>
    </span>
  );
};

export default Counter;
